export function delHtmlTag(name: string) {
  if (name) {
    return name.replace(/<[^>]+>/g, '')
  } else {
    return ''
  }
}